import React from 'react';
import { useEffect, useState } from "react";
import AppConst from "../apis/appconst";
import axios from "axios";
import { toast } from 'react-toastify';
import DataTable from 'react-data-table-component';
import jsPDF from 'jspdf';
import autoTable from 'jspdf-autotable';
import Select from 'react-select';

function StockReports() {
    const [formData, setFormData] = useState({
        stockList: [],
        search_key: '',
        from_date: new Date().toISOString().split('T')[0],
        to_date: new Date().toISOString().split('T')[0],
        statusFilter: 'all',
        categoryFilter: 'all',
        compositionFilter: 'all'
    });

    const [filteredData, setFilteredData] = useState([]);
    const [expiringMedicines, setExpiringMedicines] = useState([]);
    const [showExpiryAlert, setShowExpiryAlert] = useState(false);
    const [isLoadingExpiry, setIsLoadingExpiry] = useState(false);

    // ✅ Backend summary (reconciled with purchase_tbl + stock-level computed)
    const [summary, setSummary] = useState({});

    // ✅ Category & Composition state
    const [categories, setCategories] = useState([]);
    const [compositions, setCompositions] = useState([]);
    const [selectedCategory, setSelectedCategory] = useState(null);
    const [showCategoryModal, setShowCategoryModal] = useState(false);
    const [categoryMedicines, setCategoryMedicines] = useState([]);

    // Edit Meta Modal
    const [showEditMetaModal, setShowEditMetaModal] = useState(false);
    const [editingRow, setEditingRow] = useState(null);
    const [editCatValue, setEditCatValue] = useState(null);
    const [editCompValue, setEditCompValue] = useState(null);
    const [editMetaSaving, setEditMetaSaving] = useState(false);

    // History modal
    const [showHistoryModal, setShowHistoryModal] = useState(false);
    const [historyLoading, setHistoryLoading] = useState(false);
    const [historyMedicine, setHistoryMedicine] = useState('');
    const [historyBatch, setHistoryBatch] = useState('');
    const [historyBatchFilter, setHistoryBatchFilter] = useState('all');
    const [historyActiveTab, setHistoryActiveTab] = useState('summary');
    const [purchaseRecords, setPurchaseRecords] = useState([]);
    const [saleRecords, setSaleRecords] = useState([]);
    const [batchSummary, setBatchSummary] = useState([]);
    const [overallSummary, setOverallSummary] = useState({});



// Stock Adjustment - Add Modal
const [showAddAdjModal, setShowAddAdjModal] = useState(false);
const [adjFormData, setAdjFormData] = useState({
    adj_type: 'OUT',
    purchase_item_id: '',
    medicine_name: '',
    batch_no: '',
    adj_pkg_qty: '',
    adj_loose_qty: '',
    adj_reason: '',
    adj_transfer_to: '',
    adj_remarks: '',
    current_pkg_stock: 0,
    current_loose_stock: 0,
});
const [adjSaving, setAdjSaving] = useState(false);
 
// Stock Adjustment - List Modal
const [showAdjListModal, setShowAdjListModal] = useState(false);
const [adjList, setAdjList] = useState([]);
const [adjListLoading, setAdjListLoading] = useState(false);
const [adjListSummary, setAdjListSummary] = useState({});
const [adjListFilters, setAdjListFilters] = useState({
    from_date: new Date(Date.now() - 30 * 24 * 60 * 60 * 1000).toISOString().split('T')[0],
    to_date: new Date().toISOString().split('T')[0],
    filter_type: 'all',
    search_key: '',
});
 
// Adjustments tab inside History modal
const [adjustmentRecords, setAdjustmentRecords] = useState([]);



// Get logged-in user info from sessionStorage
const getCurrentUser = () => {
    try {
        const stored = sessionStorage.getItem('ldata');
        if (stored) {
            const parsed = JSON.parse(stored);
            return {
                user_id:   parsed.user_id   || parsed.id   || '',
                user_name: parsed.user_name || parsed.name || parsed.full_name || ''
            };
        }
    } catch (e) {}
    return { user_id: '', user_name: '' };
};
 
// Open "Add Adjustment" modal — pre-fill from row if clicked from a stock row
const openAddAdjModal = (row = null) => {
    if (row) {
        setAdjFormData({
            adj_type: 'OUT',
            purchase_item_id:    row.purchase_item_id || '',
            medicine_name:       row.purchase_item_medicine || '',
            batch_no:            row.purchase_item_batch || '',
            adj_pkg_qty:         '',
            adj_loose_qty:       '',
            adj_reason:          '',
            adj_transfer_to:     '',
            adj_remarks:         '',
            current_pkg_stock:   parseFloat(row.purchase_item_qty_stock || 0),
            current_loose_stock: parseFloat(row.purchase_item_tab_cap_stock || 0),
        });
    } else {
        setAdjFormData({
            adj_type: 'OUT',
            purchase_item_id: '',
            medicine_name: '',
            batch_no: '',
            adj_pkg_qty: '',
            adj_loose_qty: '',
            adj_reason: '',
            adj_transfer_to: '',
            adj_remarks: '',
            current_pkg_stock: 0,
            current_loose_stock: 0,
        });
    }
    setShowAddAdjModal(true);
};
 
const closeAddAdjModal = () => {
    setShowAddAdjModal(false);
    setAdjSaving(false);
};
 
// When user picks a medicine+batch from the dropdown in the modal
const handleAdjStockSelect = (selectedOption) => {
    if (!selectedOption) {
        setAdjFormData(prev => ({
            ...prev,
            purchase_item_id: '',
            medicine_name: '',
            batch_no: '',
            current_pkg_stock: 0,
            current_loose_stock: 0,
        }));
        return;
    }
    const row = formData.stockList.find(
        item => String(item.purchase_item_id) === String(selectedOption.value)
    );
    if (row) {
        setAdjFormData(prev => ({
            ...prev,
            purchase_item_id:    row.purchase_item_id,
            medicine_name:       row.purchase_item_medicine,
            batch_no:            row.purchase_item_batch,
            current_pkg_stock:   parseFloat(row.purchase_item_qty_stock || 0),
            current_loose_stock: parseFloat(row.purchase_item_tab_cap_stock || 0),
        }));
    }
};
 
// Save the adjustment
const handleSaveAdjustment = async () => {
    // Validation
    if (!adjFormData.purchase_item_id) {
        toast.error('Please select a medicine + batch');
        return;
    }
    const pkgQty   = parseFloat(adjFormData.adj_pkg_qty || 0);
    const looseQty = parseFloat(adjFormData.adj_loose_qty || 0);
    if (pkgQty <= 0 && looseQty <= 0) {
        toast.error('Enter package qty or loose qty');
        return;
    }
    if (!adjFormData.adj_reason) {
        toast.error('Please select a reason');
        return;
    }
    if (adjFormData.adj_type === 'TRANSFER' && !adjFormData.adj_transfer_to.trim()) {
        toast.error('Transfer recipient is required');
        return;
    }
    // Don't allow OUT/TRANSFER beyond current stock
    if (adjFormData.adj_type !== 'IN') {
        if (pkgQty > adjFormData.current_pkg_stock) {
            toast.error(`Package qty exceeds current stock (${adjFormData.current_pkg_stock})`);
            return;
        }
        if (looseQty > adjFormData.current_loose_stock) {
            toast.error(`Loose qty exceeds current stock (${adjFormData.current_loose_stock})`);
            return;
        }
    }
 
    setAdjSaving(true);
    try {
        const user = getCurrentUser();
        const fd = new FormData();
        fd.append('action', 'adjustment_add');
        fd.append('adj_type',         adjFormData.adj_type);
        fd.append('purchase_item_id', adjFormData.purchase_item_id);
        fd.append('adj_pkg_qty',      pkgQty);
        fd.append('adj_loose_qty',    looseQty);
        fd.append('adj_reason',       adjFormData.adj_reason);
        fd.append('adj_transfer_to',  adjFormData.adj_transfer_to);
        fd.append('adj_remarks',      adjFormData.adj_remarks);
        fd.append('user_id',          user.user_id);
        fd.append('user_name',        user.user_name);
 
        const res = await axios.post(
            AppConst.BASE_URL + AppConst.getStockReportUrl,
            fd,
            { headers: { 'Content-Type': 'multipart/form-data' } }
        );
 
        if (res.data?.status) {
            toast.success(res.data.message || 'Adjustment saved');
            closeAddAdjModal();
            // Refresh stock list so new stock values show up
            initData();
            // If list modal is open, refresh it too
            if (showAdjListModal) fetchAdjustmentList();
        } else {
            toast.error(res.data?.message || 'Failed to save');
        }
    } catch (err) {
        console.error(err);
        toast.error('Error saving adjustment');
    } finally {
        setAdjSaving(false);
    }
};
 
// Fetch adjustment list
const fetchAdjustmentList = async () => {
    setAdjListLoading(true);
    try {
        const fd = new FormData();
        fd.append('action', 'adjustment_list');
        fd.append('from_date',   adjListFilters.from_date);
        fd.append('to_date',     adjListFilters.to_date);
        fd.append('filter_type', adjListFilters.filter_type);
        fd.append('search_key',  adjListFilters.search_key);
 
        const res = await axios.post(
            AppConst.BASE_URL + AppConst.getStockReportUrl,
            fd,
            { headers: { 'Content-Type': 'multipart/form-data' } }
        );
 
        if (res.data?.status) {
            setAdjList(res.data.records || []);
            setAdjListSummary(res.data.summary || {});
        } else {
            toast.error(res.data?.message || 'Failed to load adjustments');
        }
    } catch (err) {
        console.error(err);
        toast.error('Error loading adjustments');
    } finally {
        setAdjListLoading(false);
    }
};
 
const openAdjListModal = () => {
    setShowAdjListModal(true);
    fetchAdjustmentList();
};
 
const closeAdjListModal = () => setShowAdjListModal(false);
 
// Delete an adjustment (with confirmation)
const handleDeleteAdjustment = async (adj_id, medicine_name) => {
    if (!window.confirm(
        `Delete this adjustment for "${medicine_name}"?\n\nThis will REVERSE the stock change.`
    )) return;
 
    try {
        const fd = new FormData();
        fd.append('action', 'adjustment_delete');
        fd.append('adj_id', adj_id);
 
        const res = await axios.post(
            AppConst.BASE_URL + AppConst.getStockReportUrl,
            fd,
            { headers: { 'Content-Type': 'multipart/form-data' } }
        );
 
        if (res.data?.status) {
            toast.success(res.data.message || 'Deleted');
            fetchAdjustmentList();
            initData();
        } else {
            toast.error(res.data?.message || 'Failed to delete');
        }
    } catch (err) {
        console.error(err);
        toast.error('Error deleting');
    }
};
 
// Fetch adjustments for a specific medicine — used inside the History modal
const fetchAdjustmentsForHistory = async (medicineName, batchNo = '') => {
    try {
        const fd = new FormData();
        fd.append('action', 'adjustment_by_medicine');
        fd.append('medicine_name', medicineName);
        if (batchNo) fd.append('batch_no', batchNo);
 
        const res = await axios.post(
            AppConst.BASE_URL + AppConst.getStockReportUrl,
            fd,
            { headers: { 'Content-Type': 'multipart/form-data' } }
        );
 
        if (res.data?.status) {
            setAdjustmentRecords(res.data.records || []);
        } else {
            setAdjustmentRecords([]);
        }
    } catch (err) {
        console.error(err);
        setAdjustmentRecords([]);
    }
};
 
// ⚠️ IMPORTANT: Modify your existing fetchMedicineHistory to also call this:
// In fetchMedicineHistory, AFTER the successful response, add:
//     fetchAdjustmentsForHistory(medicineName, batchNo);
// And in closeHistoryModal, add:
//     setAdjustmentRecords([]);
 
// Build the options for the medicine+batch dropdown in the Add modal
const stockOptionsForAdjustment = formData.stockList.map(item => ({
    value: String(item.purchase_item_id),
    label: `${item.purchase_item_medicine} | Batch: ${item.purchase_item_batch || '-'} | Stock: ${item.purchase_item_qty_stock || 0} pkg, ${item.purchase_item_tab_cap_stock || 0} loose`,
    medicine: item.purchase_item_medicine,
    batch: item.purchase_item_batch,
}));
 
const selectedStockOption = stockOptionsForAdjustment.find(
    opt => String(opt.value) === String(adjFormData.purchase_item_id)
) || null;
 
// Reasons by type
const reasonOptions = {
    IN: ['Found in physical count', 'Patient returned', 'Stock correction', 'Other'],
    OUT: ['Damaged', 'Expired', 'Lost', 'Sample given', 'Stock correction', 'Other'],
    TRANSFER: ['Transfer to doctor', 'Transfer to staff', 'Other'],
};



    const initData = async () => {
        const storedData = sessionStorage.getItem("ldata");

        if (storedData) {
            const fd = new FormData();
            fd.append('from_date', formData.from_date);
            fd.append('to_date', formData.to_date);
            fd.append('status_filter', formData.statusFilter);

            try {
                const response = await axios.post(
                    AppConst.BASE_URL + AppConst.getStockReportUrl,
                    fd,
                    { headers: { 'Content-Type': 'multipart/form-data' } }
                );

                if (response.data.status) {
                    const records = response.data.records;
                    if (records != null && records !== undefined) {
                        setFormData(prev => ({ ...prev, stockList: records }));
                        setFilteredData(records);
                    }

                    if (response.data.categories) setCategories(response.data.categories);
                    if (response.data.compositions) setCompositions(response.data.compositions);

                    if (response.data.summary) setSummary(response.data.summary);
                } else {
                    toast.error(response.data.message || "Failed to fetch stock data");
                }
            } catch (error) {
                console.error(error);
                toast.error("Error fetching stock reports");
            }
        }
    };

    const fetchExpiringMedicines = async () => {
        setIsLoadingExpiry(true);
        try {
            const response = await axios.post(
                AppConst.BASE_URL + AppConst.getExpiringMedicinesUrl,
                {},
                { headers: { 'Content-Type': 'multipart/form-data' } }
            );

            if (response.data.status) {
                const medicines = response.data.records || [];
                setExpiringMedicines(medicines);
                setShowExpiryAlert(true);
                if (medicines.length === 0) toast.info("No medicines expiring within 30 days");
            } else {
                toast.error(response.data.message || "Failed to fetch expiring medicines");
            }
        } catch (error) {
            console.error("Error fetching expiring medicines:", error);
            toast.error("Error fetching expiring medicines");
        } finally {
            setIsLoadingExpiry(false);
        }
    };

    const exportExpiringMedicinesToPDF = () => {
        if (expiringMedicines.length === 0) {
            toast.warning("No expiring medicines to export");
            return;
        }
        try {
            const doc = new jsPDF('l', 'mm', 'a4');
            const pageWidth = doc.internal.pageSize.getWidth();

            doc.setFontSize(18);
            doc.setFont('helvetica', 'bold');
            doc.text('Medicines Expiring Within 30 Days', pageWidth / 2, 15, { align: 'center' });

            doc.setFontSize(10);
            doc.setFont('helvetica', 'normal');
            const today = new Date().toLocaleDateString('en-GB');
            doc.text(`Report Generated: ${today}`, pageWidth / 2, 22, { align: 'center' });

            const tableHeaders = ['Sl#', 'Medicine Name', 'Supplier', 'Batch No', 'Package Qty', 'Loose Qty', 'Expiry Date', 'Days Left', 'Status'];
            const tableBody = expiringMedicines.map((medicine, index) => {
                let status = '';
                if (medicine.days_remaining <= 7) status = 'Critical';
                else if (medicine.days_remaining <= 15) status = 'Warning';
                else status = 'Notice';
                return [
                    index + 1, medicine.medicine_name || '-', medicine.supplier_name || '-',
                    medicine.batch_no || '-', medicine.package_qty || 0, medicine.loose_qty || 0,
                    medicine.expiry_date || '-',
                    `${medicine.days_remaining} day${medicine.days_remaining !== 1 ? 's' : ''}`, status
                ];
            });

            autoTable(doc, {
                startY: 35,
                head: [tableHeaders],
                body: tableBody,
                theme: 'grid',
                styles: { fontSize: 8, cellPadding: 2 },
                headStyles: { fillColor: [64, 81, 137], textColor: 255, fontStyle: 'bold' }
            });

            doc.save(`Expiring_Medicines_${new Date().toISOString().split('T')[0]}.pdf`);
            toast.success("PDF exported successfully!");
        } catch (error) {
            console.error('PDF Export error:', error);
            toast.error("Failed to export PDF");
        }
    };

    const fetchMedicineHistory = async (medicineName, batchNo = '') => {
        if (!medicineName) {
            toast.error("Medicine name is required");
            return;
        }

        setHistoryLoading(true);
        setHistoryMedicine(medicineName);
        setHistoryBatch(batchNo);
        setHistoryBatchFilter(batchNo || 'all');
        setHistoryActiveTab('summary');
        setShowHistoryModal(true);

        try {
            const fd = new FormData();
            fd.append('medicine_name', medicineName);
            if (batchNo) fd.append('batch_no', batchNo);

            const response = await axios.post(
                AppConst.BASE_URL + AppConst.getMedicineSaleHistoryUrl,
                fd,
                { headers: { 'Content-Type': 'multipart/form-data' } }
            );

            if (response.data.status) {
                setPurchaseRecords(response.data.purchase_records || []);
                setSaleRecords(response.data.sale_records || []);
                setBatchSummary(response.data.batch_summary || []);
                setOverallSummary(response.data.overall_summary || {});
            } else {
                toast.error(response.data.message || "Failed to fetch history");
                setPurchaseRecords([]);
                setSaleRecords([]);
                setBatchSummary([]);
                setOverallSummary({});
            }
        } catch (error) {
            console.error("Error fetching medicine history:", error);
            toast.error("Error fetching medicine history");
        } finally {
            setHistoryLoading(false);
        }
    };

    const handleHistoryBatchFilterChange = (batchValue) => {
        setHistoryBatchFilter(batchValue);
        if (batchValue === 'all') fetchMedicineHistory(historyMedicine, '');
        else fetchMedicineHistory(historyMedicine, batchValue);
    };

    const closeHistoryModal = () => {
        setShowHistoryModal(false);
        setPurchaseRecords([]);
        setSaleRecords([]);
        setBatchSummary([]);
        setOverallSummary({});
        setHistoryMedicine('');
        setHistoryBatch('');
        setHistoryBatchFilter('all');
        setHistoryActiveTab('summary');
    };

    const handleCategoryClick = (catId, catName) => {
        if (!catId) {
            toast.warning("No category assigned to this medicine");
            return;
        }
        const filtered = formData.stockList.filter(item =>
            String(item.cat_id) === String(catId)
        );
        setSelectedCategory({ id: catId, name: catName });
        setCategoryMedicines(filtered);
        setShowCategoryModal(true);
    };

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData(prev => ({ ...prev, [name]: value }));
    };

    const handleClearFilters = () => {
        const today = new Date().toISOString().split('T')[0];
        setFormData(prev => ({
            ...prev,
            search_key: "",
            from_date: today,
            to_date: today,
            statusFilter: 'all',
            categoryFilter: 'all',
            compositionFilter: 'all'
        }));
    };

    const handleStatusFilter = (status) => {
        setFormData(prev => ({ ...prev, statusFilter: status }));
    };

    const openEditMetaModal = (row) => {
        setEditingRow(row);

        const allCatOpts = categories.map(cat => ({
            value: String(cat.cat_id),
            label: cat.cat_name
        }));
        const currentCat = allCatOpts.find(opt => String(opt.value) === String(row.cat_id));
        setEditCatValue(currentCat || null);

        const allCompOpts = compositions.map(comp => ({ value: comp, label: comp }));
        const currentComp = allCompOpts.find(opt => String(opt.value) === String(row.composition || ''));

        if (!currentComp && row.composition) {
            setEditCompValue({ value: row.composition, label: row.composition });
        } else {
            setEditCompValue(currentComp || null);
        }

        setShowEditMetaModal(true);
    };

    const closeEditMetaModal = () => {
        setShowEditMetaModal(false);
        setEditingRow(null);
        setEditCatValue(null);
        setEditCompValue(null);
    };

    const handleSaveMeta = async () => {
        if (!editingRow) return;

        setEditMetaSaving(true);
        try {
            const fd = new FormData();
            fd.append('action', 'update');
            if (editingRow.med_id) fd.append('med_id', editingRow.med_id);
            fd.append('medicine_name', editingRow.purchase_item_medicine || '');
            fd.append('cat_id', editCatValue?.value || '');
            fd.append('composition', editCompValue?.value || '');

            const res = await axios.post(
                AppConst.BASE_URL + AppConst.getStockReportUrl,
                fd,
                { headers: { 'Content-Type': 'multipart/form-data' } }
            );

            if (res.data?.status) {
                toast.success('Updated successfully');

                setFormData(prev => ({
                    ...prev,
                    stockList: prev.stockList.map(item => {
                        if (item.purchase_item_medicine === editingRow.purchase_item_medicine) {
                            return {
                                ...item,
                                cat_id: editCatValue?.value || '',
                                cat_name: editCatValue?.label || '',
                                composition: editCompValue?.value || '',
                                med_id: res.data.med_id || item.med_id
                            };
                        }
                        return item;
                    })
                }));

                if (editCompValue?.value && !compositions.includes(editCompValue.value)) {
                    setCompositions(prev => [...prev, editCompValue.value].sort());
                }

                closeEditMetaModal();
            } else {
                toast.error(res.data?.message || 'Update failed');
            }
        } catch (err) {
            console.error('save meta error', err);
            toast.error('Save failed');
        } finally {
            setEditMetaSaving(false);
        }
    };

    // FILTER LOGIC
    useEffect(() => {
        let filtered = formData.stockList;

        if (formData.search_key.trim() !== '') {
            const searchLower = formData.search_key.toLowerCase();
            filtered = filtered.filter(item =>
                item.purchase_supplier?.toLowerCase().includes(searchLower) ||
                item.purchase_item_medicine?.toLowerCase().includes(searchLower) ||
                item.purchase_item_batch?.toLowerCase().includes(searchLower) ||
                item.cat_name?.toLowerCase().includes(searchLower) ||
                item.composition?.toLowerCase().includes(searchLower)
            );
        }

        if (formData.categoryFilter !== 'all') {
            filtered = filtered.filter(item =>
                String(item.cat_id) === String(formData.categoryFilter)
            );
        }

        if (formData.compositionFilter !== 'all') {
            filtered = filtered.filter(item =>
                String(item.composition || '').trim() === String(formData.compositionFilter).trim()
            );
        }

        if (formData.statusFilter === 'active') {
            filtered = filtered.filter(item =>
                !isExpired(item.purchase_item_expiry_month, item.purchase_item_expiry_year)
            );
        } else if (formData.statusFilter === 'expired') {
            if (formData.from_date && formData.to_date) {
                const fromDate = new Date(formData.from_date);
                fromDate.setHours(0, 0, 0, 0);
                const toDate = new Date(formData.to_date);
                toDate.setHours(23, 59, 59, 999);

                filtered = filtered.filter(item => {
                    const expMonth = parseInt(item.purchase_item_expiry_month);
                    let expYear = parseInt(item.purchase_item_expiry_year);
                    if (!expMonth || !expYear) return false;
                    if (expYear < 100) expYear = 2000 + expYear;
                    const expDate = new Date(expYear, expMonth, 0);
                    return expDate >= fromDate && expDate <= toDate;
                });
            } else {
                filtered = filtered.filter(item =>
                    isExpired(item.purchase_item_expiry_month, item.purchase_item_expiry_year)
                );
            }
        }

        setFilteredData(filtered);
    }, [formData.search_key, formData.stockList, formData.statusFilter, formData.from_date, formData.to_date, formData.categoryFilter, formData.compositionFilter]);

    useEffect(() => { initData(); }, [formData.statusFilter]);

    const isExpired = (month, year) => {
        if (!month || !year) return false;
        const currentDate = new Date();
        const currentMonth = currentDate.getMonth() + 1;
        const currentYear = currentDate.getFullYear();
        let expiryMonth = parseInt(month);
        let expiryYear = parseInt(year);
        if (expiryYear < 100) expiryYear = 2000 + expiryYear;
        if (expiryYear < currentYear) return true;
        else if (expiryYear === currentYear && expiryMonth < currentMonth) return true;
        return false;
    };

    const getMonthName = (monthNum) => {
        if (!monthNum) return '-';
        const monthNames = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
        const index = parseInt(monthNum) - 1;
        return monthNames[index] || '-';
    };

    const formatExpiryDate = (month, year) => {
        if (!month || !year) return '-';
        let fullYear = parseInt(year);
        if (fullYear < 100) fullYear = 2000 + fullYear;
        return `${getMonthName(month)}-${fullYear}`;
    };

    // ✅ Format DB date (YYYY-MM-DD or YYYY-MM-DD HH:MM:SS) → DD-MMM-YYYY
    const formatBillDate = (dateStr) => {
        if (!dateStr || dateStr === '-' || dateStr === '0000-00-00') return '-';
        try {
            const datePart = String(dateStr).split(' ')[0]; // strip time if present
            const parts = datePart.split('-');
            if (parts.length !== 3) return dateStr;
            const [y, m, d] = parts;
            const monthNames = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
            const mIdx = parseInt(m) - 1;
            if (mIdx < 0 || mIdx > 11) return dateStr;
            return `${d}-${monthNames[mIdx]}-${y}`;
        } catch (e) {
            return dateStr;
        }
    };

    // ═══════════════════════════════════════════════════════
    // ✅ Per-row line totals — CURRENT STOCK view
    //   Mirrors backend logic for filtered subsets:
    //     free_in_stock = qty_stock × (free / qty_original)   [if qty > 0]
    //     paid_in_stock = qty_stock − free_in_stock
    //     line_taxable  = paid_in_stock × pur_price × (1 − disc%)
    //     line_gst      = line_taxable × gst%
    //     line_total    = line_taxable + line_gst
    //     stock_mrp     = qty_stock × mrp
    //     line_margin   = stock_mrp − line_taxable
    // ═══════════════════════════════════════════════════════
    const computeLine = (item) => {
        const qty       = parseFloat(item.purchase_item_qty || 0);
        const qty_stock = parseFloat(item.purchase_item_qty_stock || 0);
        const free      = parseFloat(item.purchase_item_free || 0);
        const pur_price = parseFloat(item.purchase_item_pur_price || 0);
        const mrp       = parseFloat(item.purchase_item_mrp || 0);
        const disc_pct  = parseFloat(item.purchase_item_discount || 0);
        const gst_pct   = parseFloat(item.purchase_item_gst || 0);

        let free_in_stock = 0;
        let paid_in_stock = qty_stock;
        if (qty > 0) {
            const free_ratio = free / qty;
            free_in_stock = qty_stock * free_ratio;
            paid_in_stock = Math.max(0, qty_stock - free_in_stock);
        }

        const line_pre_disc = paid_in_stock * pur_price;
        const line_taxable  = line_pre_disc * (1 - disc_pct / 100);
        const line_gst      = line_taxable * (gst_pct / 100);
        const line_total    = line_taxable + line_gst;
        const stock_mrp     = qty_stock * mrp;
        const line_margin   = stock_mrp - line_taxable;
        const margin_pct    = stock_mrp > 0 ? (line_margin / stock_mrp) * 100 : 0;

        return { line_taxable, line_gst, line_total, stock_mrp, line_margin, margin_pct };
    };

    // ═══════════════════════════════════════════════════════
    // ✅ Use BACKEND summary when no filter is active.
    // When filtered, recompute on the filtered subset using the same formula.
    // ═══════════════════════════════════════════════════════
    const isFiltered =
        formData.search_key.trim() !== '' ||
        formData.categoryFilter !== 'all' ||
        formData.compositionFilter !== 'all' ||
        formData.statusFilter !== 'all';

    const stats = (() => {
        if (!isFiltered && summary && Object.keys(summary).length > 0) {
            return {
                // CURRENT STOCK (primary view)
                stockWithGst:    summary.total_stock_value_with_gst || 0,
                stockExclGst:    summary.total_stock_value_at_purprice_paid || 0,
                stockMrp:        summary.total_stock_value_at_mrp || 0,
                stockGst:        summary.total_stock_gst_amount || 0,

                // Margin on current stock
                grossMargin:     summary.gross_margin_amount || 0,
                grossMarginPct:  summary.gross_margin_pct || 0,
                grossMarkupPct:  summary.gross_markup_pct || 0,

                // ORIGINAL PURCHASE (for reference — matches Purchase List)
                originalPurchaseTotal: summary.purchase_total || 0,
                originalMrpTotal:      summary.original_mrp_total || 0,
                soldMrpValue:          summary.sold_mrp_value || 0,
                paidAmount:            summary.paid_amount || 0,
                dueAmount:             summary.due_amount || 0,

                fromBackend: true
            };
        }
        // Filtered subset — recompute on filteredData
        let taxable = 0, gst = 0, withGst = 0, mrp = 0, margin = 0;
        filteredData.forEach(item => {
            const c = computeLine(item);
            taxable += c.line_taxable;
            gst     += c.line_gst;
            withGst += c.line_total;
            mrp     += c.stock_mrp;
            margin  += c.line_margin;
        });
        const marginPct = mrp > 0 ? (margin / mrp) * 100 : 0;
        const markupPct = taxable > 0 ? (margin / taxable) * 100 : 0;
        return {
            stockWithGst:  withGst,
            stockExclGst:  taxable,
            stockMrp:      mrp,
            stockGst:      gst,
            grossMargin:   margin,
            grossMarginPct: marginPct,
            grossMarkupPct: markupPct,
            originalPurchaseTotal: null,
            originalMrpTotal:      null,
            soldMrpValue:          null,
            paidAmount:    null,
            dueAmount:     null,
            fromBackend:   false
        };
    })();

    const fmtINR = (n) => `₹${(n || 0).toLocaleString('en-IN', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;

    const exportToCSV = () => {
        try {
            const headers = ['Sl No', 'Supplier', 'Medicine', 'Category', 'Composition', 'Package Qty', 'Free', 'Loose Qty', 'Batch No', 'Expiry Date', 'Pur Price', 'Disc%', 'GST%', 'MRP', 'Stock MRP Value', 'Stock Cost (Excl GST)', 'Stock GST', 'Stock Cost (With GST)', 'Line Margin', 'Status'];

            const rows = filteredData.map((item, index) => {
                const c = computeLine(item);
                return [
                    index + 1,
                    `"${(item.purchase_supplier || '-').replace(/"/g, '""')}"`,
                    `"${(item.purchase_item_medicine || '-').replace(/"/g, '""')}"`,
                    `"${(item.cat_name || '-').replace(/"/g, '""')}"`,
                    `"${(item.composition || '-').replace(/"/g, '""')}"`,
                    item.purchase_item_qty_stock || '0',
                    item.purchase_item_free || '0',
                    item.purchase_item_tab_cap_stock || '0',
                    `"${(item.purchase_item_batch || '-').replace(/"/g, '""')}"`,
                    formatExpiryDate(item.purchase_item_expiry_month, item.purchase_item_expiry_year),
                    parseFloat(item.purchase_item_pur_price || 0).toFixed(2),
                    item.purchase_item_discount || '0',
                    item.purchase_item_gst || '0',
                    parseFloat(item.purchase_item_mrp || 0).toFixed(2),
                    c.stock_mrp.toFixed(2),
                    c.line_taxable.toFixed(2),
                    c.line_gst.toFixed(2),
                    c.line_total.toFixed(2),
                    c.line_margin.toFixed(2),
                    isExpired(item.purchase_item_expiry_month, item.purchase_item_expiry_year) ? 'Expired' : 'Not Expired'
                ];
            });

            const csvContent = [headers.join(','), ...rows.map(row => row.join(','))].join('\n');
            const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
            const link = document.createElement('a');
            const url = URL.createObjectURL(blob);
            link.setAttribute('href', url);
            link.setAttribute('download', `Stock_Report_${formData.from_date}_to_${formData.to_date}.csv`);
            link.style.visibility = 'hidden';
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
            toast.success("CSV exported successfully!");
        } catch (error) {
            console.error('Export error:', error);
            toast.error("Failed to export CSV");
        }
    };

    const handlePrint = () => { window.print(); };

    const columns = [
        { name: 'Sl No', selector: (row, index) => index + 1, sortable: false, width: '70px', center: true },
        { name: 'Supplier Name', selector: row => row.purchase_supplier, sortable: true, grow: 2, wrap: true },
        {
            name: 'Invoice No', selector: row => row.purchase_invoice, sortable: true, width: '130px',
            cell: row => (<span className="badge bg-secondary-subtle text-secondary fs-6">{row.purchase_invoice || '-'}</span>)
        },
        { name: 'Medicine Name', selector: row => row.purchase_item_medicine, sortable: true, grow: 2, wrap: true },
        {
            name: 'Action', center: true, width: '120px',
            cell: row => (
                <button type="button" className="btn btn-sm btn-outline-info"
                    title={`View full history for ${row.purchase_item_medicine}`}
                    onClick={() => fetchMedicineHistory(row.purchase_item_medicine, row.purchase_item_batch || '')}>
                    <i className="ri-history-line me-1"></i> History
                </button>
            )
        },

        {
            name: 'Adjust',
            center: true,
            width: '100px',
            cell: row => (
                <button type="button" className="btn btn-sm btn-outline-warning"
                    title="Stock adjustment (IN/OUT/Transfer)"
                    onClick={() => openAddAdjModal(row)}>
                    <i className="ri-edit-box-line"></i>
                </button>
            )
        },
        {
            name: 'Category', selector: row => row.cat_name, sortable: true, width: '200px',
            cell: row => (
                <div style={{ display: 'flex', gap: 4, alignItems: 'center', width: '100%' }}>
                    {row.cat_name ? (
                        <button type="button" className="btn btn-sm btn-outline-primary"
                            title={`View all medicines in ${row.cat_name}`}
                            onClick={() => handleCategoryClick(row.cat_id, row.cat_name)}
                            style={{ flex: 1, minWidth: 0, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>
                            <i className="ri-folder-2-line me-1"></i>{row.cat_name}
                        </button>
                    ) : (
                        <button type="button" className="btn btn-sm btn-outline-secondary"
                            onClick={() => openEditMetaModal(row)} style={{ flex: 1 }}>
                            <i className="ri-add-line me-1"></i> Set
                        </button>
                    )}
                    <button type="button" className="btn btn-sm btn-light"
                        title="Edit category & composition" onClick={() => openEditMetaModal(row)}
                        style={{ padding: '4px 8px' }}>
                        <i className="ri-edit-2-line"></i>
                    </button>
                </div>
            )
        },
        {
            name: 'Composition', selector: row => row.composition, sortable: true, width: '220px', wrap: true,
            cell: row => (
                <div style={{ width: '100%', padding: '4px 0' }}>
                    {row.composition ? (
                        <span className="badge bg-success-subtle text-success"
                            style={{
                                cursor: 'pointer', fontSize: '11px', padding: '6px 8px',
                                whiteSpace: 'normal', wordWrap: 'break-word', wordBreak: 'break-word',
                                display: 'inline-block', textAlign: 'left', lineHeight: '1.3', maxWidth: '100%'
                            }}
                            title={`Click to edit — ${row.composition}`}
                            onClick={() => openEditMetaModal(row)}>
                            <i className="ri-flask-line me-1"></i>{row.composition}
                        </span>
                    ) : (
                        <button type="button" className="btn btn-sm btn-outline-secondary"
                            onClick={() => openEditMetaModal(row)}>
                            <i className="ri-add-line me-1"></i> Set
                        </button>
                    )}
                </div>
            )
        },
        {
            name: 'Pkg Qty', selector: row => row.purchase_item_qty_stock || 0, sortable: true,
            width: '100px', center: true,
            cell: row => (<span className="badge bg-primary-subtle text-primary fs-6">{row.purchase_item_qty_stock || 0}</span>)
        },
        {
            name: 'Free', selector: row => row.purchase_item_free || 0, sortable: true,
            width: '80px', center: true,
            cell: row => {
                const f = parseInt(row.purchase_item_free || 0);
                return f > 0
                    ? <span className="badge bg-warning-subtle text-warning">+{f}</span>
                    : <span className="text-muted">-</span>;
            }
        },
        {
            name: 'Loose Qty', selector: row => row.purchase_item_tab_cap_stock || 0, sortable: true,
            width: '100px', center: true,
            cell: row => (<span className="badge bg-info-subtle text-info fs-6">{row.purchase_item_tab_cap_stock || 0}</span>)
        },
        { name: 'Batch No', selector: row => row.purchase_item_batch, sortable: true, width: '120px' },
        {
            name: 'Expiry Date',
            selector: row => formatExpiryDate(row.purchase_item_expiry_month, row.purchase_item_expiry_year),
            sortable: true, width: '120px',
            cell: row => (<span>{formatExpiryDate(row.purchase_item_expiry_month, row.purchase_item_expiry_year)}</span>)
        },
        {
            name: 'MRP', selector: row => row.purchase_item_mrp, sortable: true,
            width: '100px', right: true,
            cell: row => {
                const mrp = parseFloat(row.purchase_item_mrp);
                return mrp > 0 ? `₹${mrp.toFixed(2)}` : '';
            }
        },
        // ✅ Stock MRP Value (qty_stock × mrp) — the row's contribution to "Total MRP"
        {
            name: 'Stock MRP',
            sortable: true, right: true, width: '120px',
            selector: row => computeLine(row).stock_mrp,
            cell: row => {
                const c = computeLine(row);
                return (
                    <span title={`Qty in stock × MRP = ₹${c.stock_mrp.toFixed(2)}`}>
                        ₹{c.stock_mrp.toFixed(2)}
                    </span>
                );
            }
        },
        // ✅ Stock cost with GST — the row's contribution to "Stock Value (with GST)"
        {
            name: 'Stock Cost',
            sortable: true, right: true, width: '130px',
            selector: row => computeLine(row).line_total,
            cell: row => {
                const c = computeLine(row);
                return (
                    <span title={`Taxable: ₹${c.line_taxable.toFixed(2)} + GST: ₹${c.line_gst.toFixed(2)}`}>
                        ₹{c.line_total.toFixed(2)}
                    </span>
                );
            }
        },
        {
            name: 'Status', width: '140px', center: true,
            cell: row => {
                const expMonth = parseInt(row.purchase_item_expiry_month);
                let expYear = parseInt(row.purchase_item_expiry_year);
                if (expYear < 100) expYear = 2000 + expYear;

                if (!expMonth || !expYear) return <span className="badge bg-secondary">No Expiry</span>;

                const expDate = new Date(expYear, expMonth, 0);
                const today = new Date();
                today.setHours(0, 0, 0, 0);

                if (formData.statusFilter === 'expired' && formData.to_date) {
                    const toDate = new Date(formData.to_date);
                    toDate.setHours(23, 59, 59, 999);
                    if (expDate <= toDate) {
                        const diffDays = Math.ceil((expDate - today) / (1000 * 60 * 60 * 24));
                        if (diffDays < 0) return <span className="badge bg-danger" title={`Expired ${Math.abs(diffDays)} days ago`}>Expired</span>;
                        if (diffDays === 0) return <span className="badge bg-danger" title="Expires today">Expires Today</span>;
                        return <span className="badge bg-warning text-dark" title={`Will expire in ${diffDays} days`}>Will Expire</span>;
                    }
                }

                const diffDays = Math.ceil((expDate - today) / (1000 * 60 * 60 * 24));
                if (diffDays < 0) return <span className="badge bg-danger">Expired</span>;
                if (diffDays <= 30) return <span className="badge bg-warning text-dark">Expiring Soon</span>;
                return <span className="badge bg-success">Not Expired</span>;
            }
        },
    ];

    const customStyles = {
        headRow: { style: { backgroundColor: '#405189', color: '#fff', fontSize: '14px', fontWeight: 'bold', borderRadius: '5px 5px 0 0' } },
        headCells: { style: { color: '#fff', paddingLeft: '12px', paddingRight: '12px' } },
        rows: { style: { fontSize: '14px', '&:hover': { backgroundColor: '#f8f9fa' } } }
    };

    const categoryOptions = [
        { value: 'all', label: `All Categories (${categories.length})` },
        ...categories.map(cat => ({ value: String(cat.cat_id), label: cat.cat_name }))
    ];
    const selectedCategoryOption = categoryOptions.find(opt => opt.value === String(formData.categoryFilter)) || categoryOptions[0];
    const handleCategoryFilterChange = (selectedOption) => {
        setFormData(prev => ({ ...prev, categoryFilter: selectedOption ? selectedOption.value : 'all' }));
    };

    const compositionOptions = [
        { value: 'all', label: `All Compositions (${compositions.length})` },
        ...compositions.map(comp => ({ value: comp, label: comp }))
    ];
    const selectedCompositionOption = compositionOptions.find(opt => String(opt.value) === String(formData.compositionFilter)) || compositionOptions[0];
    const handleCompositionFilterChange = (selectedOption) => {
        setFormData(prev => ({ ...prev, compositionFilter: selectedOption ? selectedOption.value : 'all' }));
    };

    const uniqueBatchesInHistory = batchSummary.map(b => b.batch_no);

    return (
        <div className="page-content">
            <div className="container-fluid">
                <div className="row">
                    <div className="col-lg-12">
                        <div className="card">
                            <div className="card-header border-0">
                                <div className="row align-items-center gy-3">
                                    <div className="col-sm">
                                        <h5 className="card-title mb-0">
                                            <i className="ri-file-list-3-line me-2"></i> Stock Reports
                                        </h5>
                                    </div>
                                    <div className="col-sm-auto">
                                        <div className="d-flex gap-2 flex-wrap">
                                            <button type="button" className="btn btn-warning"
                                                onClick={fetchExpiringMedicines} disabled={isLoadingExpiry}>
                                                <i className={`${isLoadingExpiry ? 'ri-loader-4-line rotating' : 'ri-alarm-warning-line'} align-bottom me-1`}></i>
                                                {isLoadingExpiry ? 'Loading...' : 'Expiring Medicines'}
                                                {expiringMedicines.length > 0 && !isLoadingExpiry && (
                                                    <span className="badge bg-danger ms-2">{expiringMedicines.length}</span>
                                                )}
                                            </button>




                                            <button type="button" className="btn btn-secondary"
        onClick={() => openAddAdjModal()}>
        <i className="ri-edit-box-line align-bottom me-1"></i> + Adjustment
    </button>
    <button type="button" className="btn btn-dark"
        onClick={openAdjListModal}>
        <i className="ri-list-settings-line align-bottom me-1"></i> View Adjustments
    </button>
                                            <button type="button" className="btn btn-success"
                                                onClick={exportToCSV} disabled={filteredData.length === 0}>
                                                <i className="ri-file-excel-line align-bottom me-1"></i> Export Excel
                                            </button>
                                            <button type="button" className="btn btn-info no-print"
                                                onClick={handlePrint} disabled={filteredData.length === 0}>
                                                <i className="ri-printer-line align-bottom me-1"></i> Print
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div className="card-body border border-dashed border-end-0 border-start-0 no-print">
                                <div className="row g-3">
                                    <div className="col-md-2">
                                        <label className="form-label">From Date</label>
                                        <input className="form-control" type="date" name="from_date"
                                            onChange={handleChange} value={formData.from_date} />
                                    </div>
                                    <div className="col-md-2">
                                        <label className="form-label">To Date</label>
                                        <input className="form-control" type="date" name="to_date"
                                            onChange={handleChange} value={formData.to_date} />
                                    </div>
                                    <div className="col-md-2">
                                        <label className="form-label"><i className="ri-folder-2-line me-1"></i>Category</label>
                                        <Select options={categoryOptions} value={selectedCategoryOption}
                                            onChange={handleCategoryFilterChange} placeholder="Select category..."
                                            isSearchable={true} isClearable={false}
                                            styles={{
                                                control: (base) => ({ ...base, minHeight: '38px', borderColor: '#ced4da', '&:hover': { borderColor: '#86b7fe' } }),
                                                menu: (base) => ({ ...base, zIndex: 9999 }),
                                                option: (base, state) => ({ ...base, backgroundColor: state.isSelected ? '#405189' : state.isFocused ? '#e7f1ff' : 'white', color: state.isSelected ? 'white' : '#333', cursor: 'pointer' })
                                            }}
                                            noOptionsMessage={() => "No categories found"} />
                                    </div>
                                    <div className="col-md-2">
                                        <label className="form-label"><i className="ri-flask-line me-1"></i>Composition</label>
                                        <Select options={compositionOptions} value={selectedCompositionOption}
                                            onChange={handleCompositionFilterChange} placeholder="Select composition..."
                                            isSearchable={true} isClearable={false}
                                            styles={{
                                                control: (base) => ({ ...base, minHeight: '38px', borderColor: '#ced4da', '&:hover': { borderColor: '#86b7fe' } }),
                                                menu: (base) => ({ ...base, zIndex: 9999 }),
                                                option: (base, state) => ({ ...base, backgroundColor: state.isSelected ? '#198754' : state.isFocused ? '#d1e7dd' : 'white', color: state.isSelected ? 'white' : '#333', cursor: 'pointer' })
                                            }}
                                            noOptionsMessage={() => "No compositions found"} />
                                    </div>
                                    <div className="col-md-2">
                                        <label className="form-label">Search</label>
                                        <input className="form-control" placeholder="Search..." type="text"
                                            name="search_key" onChange={handleChange} value={formData.search_key} />
                                    </div>
                                    <div className="col-md-2">
                                        <label className="form-label">&nbsp;</label>
                                        <button type="button" onClick={handleClearFilters} className="btn btn-info w-100">
                                            <i className="ri-refresh-line me-1"></i> Clear
                                        </button>
                                    </div>
                                </div>

                                <div className="row mt-3">
                                    <div className="col-12">
                                        <label className="form-label">Filter by Status:</label>
                                        <div className="btn-group w-100" role="group">
                                            <button type="button"
                                                className={`btn ${formData.statusFilter === 'all' ? 'btn-primary' : 'btn-outline-primary'}`}
                                                onClick={() => handleStatusFilter('all')}>
                                                <i className="ri-list-check me-1"></i> All Products
                                                <span className="badge bg-light text-dark ms-2">{formData.stockList.length}</span>
                                            </button>
                                            <button type="button"
                                                className={`btn ${formData.statusFilter === 'active' ? 'btn-success' : 'btn-outline-success'}`}
                                                onClick={() => handleStatusFilter('active')}>
                                                <i className="ri-checkbox-circle-line me-1"></i> Active Products
                                                <span className="badge bg-light text-dark ms-2">
                                                    {formData.stockList.filter(item => !isExpired(item.purchase_item_expiry_month, item.purchase_item_expiry_year)).length}
                                                </span>
                                            </button>
                                            <button type="button"
                                                className={`btn ${formData.statusFilter === 'expired' ? 'btn-danger' : 'btn-outline-danger'}`}
                                                onClick={() => handleStatusFilter('expired')}>
                                                <i className="ri-close-circle-line me-1"></i> Expired Products
                                                <span className="badge bg-light text-dark ms-2">
                                                    {formData.stockList.filter(item => isExpired(item.purchase_item_expiry_month, item.purchase_item_expiry_year)).length}
                                                </span>
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div className="card-body pt-0">
                                <DataTable columns={columns} data={filteredData} customStyles={customStyles}
                                    pagination paginationPerPage={25}
                                    paginationRowsPerPageOptions={[10, 25, 50, 100, 200]}
                                    highlightOnHover responsive striped dense
                                    noDataComponent={
                                        <div className="text-center py-5">
                                            <i className="ri-inbox-line fs-1 text-muted"></i>
                                            <p className="mt-3">No stock records found</p>
                                        </div>
                                    } />

                                {/* ════════════════════════════════════════════════════
                                     ✅ SUMMARY — CURRENT STOCK VIEW (consistent)
                                     ════════════════════════════════════════════════════ */}
                                <div className="mt-3 p-3 bg-light rounded">
                                    {!isFiltered && stats.fromBackend && (
                                        <div className="alert alert-info py-2 mb-3 small">
                                            <i className="ri-information-line me-1"></i>
                                            Totals reflect <strong>current stock only</strong> — they change as items are sold.
                                            Free items excluded, discount applied, GST included.
                                        </div>
                                    )}
                                    {isFiltered && (
                                        <div className="alert alert-warning py-2 mb-3 small">
                                            <i className="ri-filter-3-line me-1"></i>
                                            Showing computed totals for filtered subset only.
                                        </div>
                                    )}

                                    {/* PRIMARY CARDS — Current Stock */}
                                    <div className="row text-center g-3">
                                        <div className="col-md-2">
                                            <div className="border-end">
                                                <strong className="text-muted small">Total Records</strong>
                                                <div className="fs-5 fw-bold text-primary">{filteredData.length}</div>
                                            </div>
                                        </div>
                                        <div className="col-md-2">
                                            <div className="border-end">
                                                <strong className="text-muted small">Expired Items</strong>
                                                <div className="fs-5 fw-bold text-danger">
                                                    {filteredData.filter(item => isExpired(item.purchase_item_expiry_month, item.purchase_item_expiry_year)).length}
                                                </div>
                                            </div>
                                        </div>
                                        <div className="col-md-2">
                                            <div className="border-end">
                                                <strong className="text-muted small">Active Items</strong>
                                                <div className="fs-5 fw-bold text-success">
                                                    {filteredData.filter(item => !isExpired(item.purchase_item_expiry_month, item.purchase_item_expiry_year)).length}
                                                </div>
                                            </div>
                                        </div>
                                        <div className="col-md-3">
                                            <div className="border-end">
                                                <strong className="text-muted small">
                                                    <i className="ri-shopping-cart-2-line me-1"></i>
                                                    Total Amount (Current Stock)
                                                </strong>
                                                <div className="fs-5 fw-bold text-info">
                                                    {fmtINR(stats.stockWithGst)}
                                                </div>
                                                <small className="text-muted">Free excluded · disc. applied · GST included</small>
                                            </div>
                                        </div>
                                        <div className="col-md-3">
                                            <div>
                                                <strong className="text-muted small">
                                                    <i className="ri-price-tag-3-line me-1"></i>Total MRP (Current Stock)
                                                </strong>
                                                <div className="fs-5 fw-bold text-warning">
                                                    {fmtINR(stats.stockMrp)}
                                                </div>
                                                <small className="text-muted">Qty in stock × MRP</small>
                                            </div>
                                        </div>
                                    </div>

                                    {/* COST BREAKDOWN */}
                                    <div className="row text-center g-3 mt-2 pt-3 border-top">
                                        <div className="col-md-3">
                                            <strong className="text-muted small">Stock Cost (Excl. GST)</strong>
                                            <div className="fs-6 fw-semibold text-secondary">
                                                {fmtINR(stats.stockExclGst)}
                                            </div>
                                            <small className="text-muted">Current stock at pur. price</small>
                                        </div>
                                        <div className="col-md-3">
                                            <strong className="text-muted small">Gross Margin (₹)</strong>
                                            <div className="fs-6 fw-semibold text-success">
                                                {fmtINR(stats.grossMargin)}
                                            </div>
                                            <small className="text-muted">MRP − Cost (excl. GST)</small>
                                        </div>
                                        <div className="col-md-3">
                                            <strong className="text-muted small">Margin / Markup</strong>
                                            <div className="fs-6 fw-semibold text-primary">
                                                {(stats.grossMarginPct || 0).toFixed(2)}%
                                                <small className="text-muted ms-2">/ {(stats.grossMarkupPct || 0).toFixed(2)}%</small>
                                            </div>
                                            <small className="text-muted">On sale / On cost</small>
                                        </div>
                                        {stats.fromBackend && (
                                            <div className="col-md-3">
                                                <strong className="text-muted small">Paid / Due</strong>
                                                <div className="fs-6 fw-semibold">
                                                    <span className="text-success">{fmtINR(stats.paidAmount)}</span>
                                                    <span className="text-muted mx-1">/</span>
                                                    <span className="text-danger">{fmtINR(stats.dueAmount)}</span>
                                                </div>
                                                <small className="text-muted">Paid · Outstanding</small>
                                            </div>
                                        )}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            {/* EDIT META MODAL */}
            {showEditMetaModal && editingRow && (
                <>
                    <div className="modal fade show" style={{ display: 'block', zIndex: 1070 }} tabIndex="-1">
                        <div className="modal-dialog modal-dialog-centered">
                            <div className="modal-content">
                                <div className="modal-header" style={{ backgroundColor: '#405189', color: '#fff' }}>
                                    <h5 className="modal-title">
                                        <i className="ri-edit-2-line me-2"></i> Edit Category & Composition
                                    </h5>
                                    <button type="button" className="btn-close btn-close-white" onClick={closeEditMetaModal}></button>
                                </div>
                                <div className="modal-body">
                                    <div className="alert alert-info mb-3">
                                        <strong>Medicine:</strong> {editingRow.purchase_item_medicine}
                                        <br />
                                        <small className="text-muted">Changes will apply to ALL stock entries with this medicine name</small>
                                    </div>
                                    <div className="mb-3">
                                        <label className="form-label fw-bold">
                                            <i className="ri-folder-2-line me-1 text-primary"></i> Category
                                            <small className="text-muted ms-2">({categories.length} available)</small>
                                        </label>
                                        <Select
                                            options={categories.map(cat => ({ value: String(cat.cat_id), label: cat.cat_name }))}
                                            value={editCatValue} onChange={(opt) => setEditCatValue(opt)}
                                            placeholder="Click to see all categories..." isSearchable={true} isClearable={true}
                                            openMenuOnFocus={true} openMenuOnClick={true}
                                            styles={{
                                                menu: (base) => ({ ...base, zIndex: 99999 }),
                                                menuPortal: (base) => ({ ...base, zIndex: 99999 }),
                                                control: (base) => ({ ...base, minHeight: '40px' })
                                            }}
                                            menuPortalTarget={document.body}
                                            noOptionsMessage={() => "No categories found"} />
                                    </div>
                                    <div className="mb-3">
                                        <label className="form-label fw-bold">
                                            <i className="ri-flask-line me-1 text-success"></i> Composition
                                            <small className="text-muted ms-2">({compositions.length} existing — or type new)</small>
                                        </label>
                                        <Select
                                            options={compositions.map(comp => ({ value: comp, label: comp }))}
                                            value={editCompValue} onChange={(opt) => setEditCompValue(opt)}
                                            placeholder="Click to see all compositions or type new..."
                                            isSearchable={true} isClearable={true}
                                            openMenuOnFocus={true} openMenuOnClick={true}
                                            onInputChange={(input, { action }) => {
                                                if (action === 'input-change' && input && input.trim()) {
                                                    setEditCompValue({ value: input, label: input });
                                                }
                                            }}
                                            styles={{
                                                menu: (base) => ({ ...base, zIndex: 99999 }),
                                                menuPortal: (base) => ({ ...base, zIndex: 99999 }),
                                                control: (base) => ({ ...base, minHeight: '40px' })
                                            }}
                                            menuPortalTarget={document.body}
                                            noOptionsMessage={({ inputValue }) =>
                                                inputValue ? `Type "${inputValue}" — it will be saved as new composition`
                                                    : compositions.length === 0 ? "No compositions saved yet — type one to add"
                                                        : "No matches — keep typing to add new"
                                            } />
                                    </div>
                                    <div className="bg-light p-2 rounded">
                                        <small className="text-muted d-block mb-1"><strong>Current values:</strong></small>
                                        <small>
                                            Category: <span className="badge bg-primary-subtle text-primary">{editingRow.cat_name || '-'}</span>
                                            <br />
                                            Composition: <span className="badge bg-success-subtle text-success"
                                                style={{ whiteSpace: 'normal', wordBreak: 'break-word', textAlign: 'left' }}>
                                                {editingRow.composition || '-'}
                                            </span>
                                        </small>
                                    </div>
                                </div>
                                <div className="modal-footer">
                                    <button type="button" className="btn btn-secondary" onClick={closeEditMetaModal} disabled={editMetaSaving}>
                                        <i className="ri-close-line me-1"></i> Cancel
                                    </button>
                                    <button type="button" className="btn btn-primary" onClick={handleSaveMeta} disabled={editMetaSaving}>
                                        {editMetaSaving ? (<><span className="spinner-border spinner-border-sm me-1" /> Saving...</>) : (<><i className="ri-save-line me-1" /> Save Changes</>)}
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="modal-backdrop fade show" style={{ zIndex: 1065 }}></div>
                </>
            )}

            {/* HISTORY MODAL */}
            {showHistoryModal && (
                <>
                    <div className="modal fade show" style={{ display: 'block', zIndex: 1060 }} tabIndex="-1">
                        <div className="modal-dialog modal-xl modal-dialog-scrollable">
                            <div className="modal-content">
                                <div className="modal-header" style={{ backgroundColor: '#405189', color: '#fff' }}>
                                    <h5 className="modal-title">
                                        <i className="ri-history-line me-2"></i>
                                        Medicine History — {historyMedicine}
                                        {historyBatch && (<span className="badge bg-warning text-dark ms-2">Batch: {historyBatch}</span>)}
                                    </h5>
                                    <button type="button" className="btn-close btn-close-white" onClick={closeHistoryModal}></button>
                                </div>
                                <div className="modal-body">
                                    {historyLoading ? (
                                        <div className="text-center py-5">
                                            <div className="spinner-border text-primary" role="status">
                                                <span className="visually-hidden">Loading...</span>
                                            </div>
                                            <p className="mt-3 text-muted">Loading history...</p>
                                        </div>
                                    ) : (
                                        <>
                                            <div className="row mb-3">
                                                <div className="col-md-4">
                                                    <label className="form-label fw-bold">
                                                        <i className="ri-filter-3-line me-1"></i>Filter by Batch
                                                    </label>
                                                    <select className="form-select form-select-sm" value={historyBatchFilter}
                                                        onChange={(e) => handleHistoryBatchFilterChange(e.target.value)}>
                                                        <option value="all">All Batches ({overallSummary.total_batches || uniqueBatchesInHistory.length})</option>
                                                        {uniqueBatchesInHistory.map((batch, idx) => (
                                                            <option key={idx} value={batch}>{batch}</option>
                                                        ))}
                                                    </select>
                                                </div>
                                            </div>
                                            <ul className="nav nav-tabs nav-justified mb-3" role="tablist">
                                                <li className="nav-item">
                                                    <button className={`nav-link ${historyActiveTab === 'summary' ? 'active' : ''}`}
                                                        onClick={() => setHistoryActiveTab('summary')}>
                                                        <i className="ri-pie-chart-line me-1"></i> Batch Summary
                                                    </button>
                                                </li>
                                                <li className="nav-item">
                                                    <button className={`nav-link ${historyActiveTab === 'purchase' ? 'active' : ''}`}
                                                        onClick={() => setHistoryActiveTab('purchase')}>
                                                        <i className="ri-shopping-cart-line me-1"></i> Purchase ({purchaseRecords.length})
                                                    </button>
                                                </li>
                                                <li className="nav-item">
                                                    <button className={`nav-link ${historyActiveTab === 'sale' ? 'active' : ''}`}
                                                        onClick={() => setHistoryActiveTab('sale')}>
                                                        <i className="ri-shopping-bag-line me-1"></i> Sale ({saleRecords.length})
                                                    </button>
                                                </li>


                                                <li className="nav-item">
        <button className={`nav-link ${historyActiveTab === 'adjustment' ? 'active' : ''}`}
            onClick={() => setHistoryActiveTab('adjustment')}>
            <i className="ri-edit-box-line me-1"></i> Adjustments ({adjustmentRecords.length})
        </button>
    </li>
                                            </ul>
                                            <div className="tab-content">
                                                {/* SUMMARY TAB */}
                                                {historyActiveTab === 'summary' && (
                                                    <div className="tab-pane fade show active">
                                                        <div className="row mb-3 g-2">
                                                            <div className="col-md-3">
                                                                <div className="card bg-primary-subtle">
                                                                    <div className="card-body py-2 text-center">
                                                                        <small className="text-muted d-block">Total Purchased</small>
                                                                        <div className="fs-5 fw-bold text-primary">
                                                                            {overallSummary.total_purchase_pkg || 0} pkg
                                                                        </div>
                                                                        <small className="text-muted">
                                                                            ({overallSummary.total_purchase_loose || 0} loose · {overallSummary.total_purchase_count || 0} bills)
                                                                        </small>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                            <div className="col-md-3">
                                                                <div className="card bg-success-subtle">
                                                                    <div className="card-body py-2 text-center">
                                                                        <small className="text-muted d-block">Total Sold</small>
                                                                        <div className="fs-5 fw-bold text-success">
                                                                            {overallSummary.total_sale_pkg || 0} pkg
                                                                        </div>
                                                                        <small className="text-muted">
                                                                            ({overallSummary.total_sale_loose || 0} loose · {overallSummary.total_sale_count || 0} bills)
                                                                        </small>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                            <div className="col-md-3">
                                                                <div className="card bg-warning-subtle">
                                                                    <div className="card-body py-2 text-center">
                                                                        <small className="text-muted d-block">Current Stock</small>
                                                                        <div className="fs-5 fw-bold text-warning">
                                                                            {overallSummary.total_closing_pkg || 0} pkg
                                                                        </div>
                                                                        <small className="text-muted">
                                                                            ({overallSummary.total_closing_loose || 0} loose)
                                                                        </small>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                            <div className="col-md-3">
                                                                <div className="card bg-info-subtle">
                                                                    <div className="card-body py-2 text-center">
                                                                        <small className="text-muted d-block">Total Batches</small>
                                                                        <div className="fs-5 fw-bold text-info">
                                                                            {overallSummary.total_batches || batchSummary.length}
                                                                        </div>
                                                                        <small className="text-muted">
                                                                            {overallSummary.unique_patients || 0} unique patients
                                                                        </small>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>

                                                        {batchSummary.length > 0 ? (
                                                            <div className="table-responsive">
                                                                <table className="table table-bordered table-hover table-sm align-middle">
                                                                    <thead style={{ backgroundColor: '#405189', color: '#fff' }}>
                                                                        <tr>
                                                                            <th>Sl#</th>
                                                                            <th>Batch No</th>
                                                                            <th>Supplier</th>
                                                                            <th>Purchased</th>
                                                                            <th>Sold</th>
                                                                            <th>In Stock</th>
                                                                            <th>Expiry</th>
                                                                        </tr>
                                                                    </thead>
                                                                    <tbody>
                                                                        {batchSummary.map((b, idx) => (
                                                                            <tr key={idx}>
                                                                                <td>{idx + 1}</td>
                                                                                <td><span className="badge bg-info-subtle text-info">{b.batch_no || '-'}</span></td>
                                                                                <td>{b.supplier || '-'}</td>
                                                                                <td className="text-center">
                                                                                    <span className="badge bg-primary">
                                                                                        {b.purchase_pkg_qty ?? b.purchase_pkg ?? b.purchased ?? 0}
                                                                                    </span>
                                                                                    {(b.purchase_free_qty > 0) && (
                                                                                        <small className="text-muted ms-1">
                                                                                            (+{b.purchase_free_qty} free)
                                                                                        </small>
                                                                                    )}
                                                                                </td>
                                                                                <td className="text-center">
                                                                                    <span className="badge bg-success">
                                                                                        {b.sale_pkg_qty ?? b.sale_pkg ?? b.sold ?? 0}
                                                                                    </span>
                                                                                    {(b.sale_loose_qty > 0) && (
                                                                                        <small className="text-muted ms-1">
                                                                                            (+{b.sale_loose_qty} loose)
                                                                                        </small>
                                                                                    )}
                                                                                </td>
                                                                                <td className="text-center">
                                                                                    <span className="badge bg-warning text-dark">
                                                                                        {b.closing_pkg_qty ?? b.closing_pkg ?? b.in_stock ?? 0}
                                                                                    </span>
                                                                                </td>
                                                                                <td>{b.expiry || formatExpiryDate(b.expiry_month, b.expiry_year)}</td>
                                                                            </tr>
                                                                        ))}
                                                                    </tbody>
                                                                </table>
                                                            </div>
                                                        ) : (
                                                            <div className="text-center py-4">
                                                                <i className="ri-inbox-line" style={{ fontSize: '48px', color: '#ccc' }}></i>
                                                                <p className="mt-3 text-muted">No batch summary available</p>
                                                            </div>
                                                        )}
                                                    </div>
                                                )}

                                                {/* PURCHASE TAB */}
                                                {historyActiveTab === 'purchase' && (
                                                    <div className="tab-pane fade show active">
                                                        {purchaseRecords.length > 0 ? (
                                                            <div className="table-responsive">
                                                                <table className="table table-bordered table-hover table-sm align-middle">
                                                                    <thead style={{ backgroundColor: '#198754', color: '#fff' }}>
                                                                        <tr>
                                                                            <th>Sl#</th>
                                                                            <th>Date</th>
                                                                            <th>Invoice No</th>
                                                                            <th>Supplier</th>
                                                                            <th>Batch</th>
                                                                            <th>Pkg Qty</th>
                                                                            <th>Free</th>
                                                                            <th>Loose Qty</th>
                                                                            <th>Pur Price</th>
                                                                            <th>MRP</th>
                                                                            <th>Expiry</th>
                                                                        </tr>
                                                                    </thead>
                                                                    <tbody>
                                                                        {purchaseRecords.map((p, idx) => (
                                                                            <tr key={idx}>
                                                                                <td>{idx + 1}</td>
                                                                                <td>{formatBillDate(p.purchase_date)}</td>
                                                                                <td>
                                                                                    <span className="badge bg-secondary-subtle text-secondary">
                                                                                        {p.purchase_invoice || '-'}
                                                                                    </span>
                                                                                </td>
                                                                                <td>{p.purchase_supplier || '-'}</td>
                                                                                <td>
                                                                                    <span className="badge bg-info-subtle text-info">
                                                                                        {p.purchase_item_batch || '-'}
                                                                                    </span>
                                                                                </td>
                                                                                <td className="text-center">{p.purchase_item_qty || 0}</td>
                                                                                <td className="text-center">
                                                                                    {parseInt(p.purchase_item_free || 0) > 0 ? (
                                                                                        <span className="badge bg-warning-subtle text-warning">
                                                                                            +{p.purchase_item_free}
                                                                                        </span>
                                                                                    ) : '-'}
                                                                                </td>
                                                                                <td className="text-center">{p.purchase_item_tab_cap || 0}</td>
                                                                                <td className="text-end">
                                                                                    ₹{parseFloat(p.purchase_item_pur_price || 0).toFixed(2)}
                                                                                </td>
                                                                                <td className="text-end">
                                                                                    ₹{parseFloat(p.purchase_item_mrp || 0).toFixed(2)}
                                                                                </td>
                                                                                <td>{formatExpiryDate(p.purchase_item_expiry_month, p.purchase_item_expiry_year)}</td>
                                                                            </tr>
                                                                        ))}
                                                                    </tbody>
                                                                </table>
                                                            </div>
                                                        ) : (
                                                            <div className="text-center py-5">
                                                                <i className="ri-inbox-line" style={{ fontSize: '48px', color: '#ccc' }}></i>
                                                                <p className="mt-3 text-muted">No purchase records found</p>
                                                            </div>
                                                        )}
                                                    </div>
                                                )}

                                                {/* SALE TAB */}
                                                {historyActiveTab === 'sale' && (
                                                    <div className="tab-pane fade show active">
                                                        {saleRecords.length > 0 ? (
                                                            <div className="table-responsive">
                                                                <table className="table table-bordered table-hover table-sm align-middle">
                                                                    <thead style={{ backgroundColor: '#dc3545', color: '#fff' }}>
                                                                        <tr>
                                                                            <th>Sl#</th>
                                                                            <th>Date</th>
                                                                            <th>Bill No</th>
                                                                            <th>Patient</th>
                                                                            <th>Batch</th>
                                                                            <th>Qty</th>
                                                                            <th>Type</th>
                                                                            <th>MRP</th>
                                                                            <th>Disc%</th>
                                                                            <th>Tax</th>
                                                                            <th>Total</th>
                                                                        </tr>
                                                                    </thead>
                                                                    <tbody>
                                                                        {saleRecords.map((s, idx) => {
                                                                            // ✅ Match med_bill_tbl + med_bill_item_tbl real columns
                                                                            //    with safe fallbacks in case backend aliases them
                                                                            const date = formatBillDate(s.med_bill_date || s.sale_date || s.bill_date);
                                                                            const billNo = s.med_bill_ipd_number || s.bill_no || s.sale_invoice || s.med_bill_id || '-';
                                                                            const patient = s.med_bill_patient_number || s.patient_name || s.customer_name || '-';
                                                                            const batch = s.med_bill_item_batch || s.sale_item_batch || s.batch_no || '-';
                                                                            const qty = s.med_bill_item_qty ?? s.sale_item_qty ?? s.qty ?? 0;
                                                                            const isLoose = parseInt(s.med_bill_item_is_loose ?? s.is_loose ?? 0);
                                                                            const mrp = parseFloat(s.med_bill_item_mrp || s.sale_item_rate || s.rate || 0);
                                                                            const discount = parseFloat(s.med_bill_item_discount || s.discount || 0);
                                                                            const tax = parseFloat(s.med_bill_item_tax_amt || s.tax || 0);
                                                                            const total = parseFloat(s.med_bill_item_total || s.sale_item_total || s.amount || 0);

                                                                            return (
                                                                                <tr key={idx}>
                                                                                    <td>{idx + 1}</td>
                                                                                    <td>{date}</td>
                                                                                    <td>
                                                                                        <span className="badge bg-secondary-subtle text-secondary">
                                                                                            {billNo}
                                                                                        </span>
                                                                                    </td>
                                                                                    <td>{patient}</td>
                                                                                    <td>
                                                                                        <span className="badge bg-info-subtle text-info">
                                                                                            {batch}
                                                                                        </span>
                                                                                    </td>
                                                                                    <td className="text-center">{qty}</td>
                                                                                    <td className="text-center">
                                                                                        {isLoose === 1 ? (
                                                                                            <span className="badge bg-warning-subtle text-warning">Loose</span>
                                                                                        ) : (
                                                                                            <span className="badge bg-primary-subtle text-primary">Pkg</span>
                                                                                        )}
                                                                                    </td>
                                                                                    <td className="text-end">₹{mrp.toFixed(2)}</td>
                                                                                    <td className="text-center">{discount > 0 ? `${discount}%` : '-'}</td>
                                                                                    <td className="text-end">₹{tax.toFixed(2)}</td>
                                                                                    <td className="text-end fw-semibold">₹{total.toFixed(2)}</td>
                                                                                </tr>
                                                                            );
                                                                        })}
                                                                    </tbody>
                                                                </table>
                                                            </div>
                                                        ) : (
                                                            <div className="text-center py-5">
                                                                <i className="ri-inbox-line" style={{ fontSize: '48px', color: '#ccc' }}></i>
                                                                <p className="mt-3 text-muted">No sale records found</p>
                                                            </div>
                                                        )}
                                                    </div>
                                                )}



{historyActiveTab === 'adjustment' && (
    <div className="tab-pane fade show active">
        {adjustmentRecords.length > 0 ? (
            <div className="table-responsive">
                <table className="table table-bordered table-hover table-sm align-middle">
                    <thead style={{ backgroundColor: '#fd7e14', color: '#fff' }}>
                        <tr>
                            <th>Sl#</th>
                            <th>Date</th>
                            <th>Type</th>
                            <th>Batch</th>
                            <th>Pkg Qty</th>
                            <th>Loose Qty</th>
                            <th>Reason</th>
                            <th>Transfer To</th>
                            <th>Remarks</th>
                            <th>By</th>
                        </tr>
                    </thead>
                    <tbody>
                        {adjustmentRecords.map((r, idx) => {
                            const typeColor = r.adj_type === 'IN' ? 'success'
                                           : r.adj_type === 'OUT' ? 'danger' : 'warning';
                            const sign = r.adj_type === 'IN' ? '+' : '-';
                            return (
                                <tr key={r.adj_id}>
                                    <td>{idx + 1}</td>
                                    <td>{formatBillDate(r.adj_datetime)}</td>
                                    <td>
                                        <span className={`badge bg-${typeColor}`}>
                                            {r.adj_type}
                                        </span>
                                    </td>
                                    <td>
                                        <span className="badge bg-info-subtle text-info">
                                            {r.adj_batch || '-'}
                                        </span>
                                    </td>
                                    <td className="text-center fw-bold">
                                        {parseFloat(r.adj_pkg_qty) > 0 ? `${sign}${r.adj_pkg_qty}` : '-'}
                                    </td>
                                    <td className="text-center fw-bold">
                                        {parseFloat(r.adj_loose_qty) > 0 ? `${sign}${r.adj_loose_qty}` : '-'}
                                    </td>
                                    <td>{r.adj_reason}</td>
                                    <td>{r.adj_transfer_to || '-'}</td>
                                    <td><small>{r.adj_remarks || '-'}</small></td>
                                    <td><small>{r.adj_user_name || '-'}</small></td>
                                </tr>
                            );
                        })}
                    </tbody>
                </table>
            </div>
        ) : (
            <div className="text-center py-4">
                <i className="ri-inbox-line" style={{ fontSize: '48px', color: '#ccc' }}></i>
                <p className="mt-3 text-muted">No stock adjustments for this medicine</p>
            </div>
        )}
    </div>
)}
                                            </div>
                                        </>
                                    )}
                                </div>
                                <div className="modal-footer">
                                    <button type="button" className="btn btn-secondary" onClick={closeHistoryModal}>Close</button>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="modal-backdrop fade show" style={{ zIndex: 1055 }}></div>
                </>
            )}

            {/* CATEGORY MEDICINES MODAL */}
            {showCategoryModal && selectedCategory && (
                <>
                    <div className="modal fade show" style={{ display: 'block', zIndex: 1060 }} tabIndex="-1">
                        <div className="modal-dialog modal-xl modal-dialog-scrollable">
                            <div className="modal-content">
                                <div className="modal-header" style={{ backgroundColor: '#0d6efd', color: '#fff' }}>
                                    <h5 className="modal-title">
                                        <i className="ri-folder-2-line me-2"></i>
                                        Medicines in Category — {selectedCategory.name}
                                        <span className="badge bg-light text-dark ms-2">{categoryMedicines.length} items</span>
                                    </h5>
                                    <button type="button" className="btn-close btn-close-white" onClick={() => setShowCategoryModal(false)}></button>
                                </div>
                                <div className="modal-body">
                                    {categoryMedicines.length > 0 ? (
                                        <div className="table-responsive">
                                            <table className="table table-bordered table-hover table-sm align-middle">
                                                <thead style={{ backgroundColor: '#0d6efd', color: '#fff' }}>
                                                    <tr>
                                                        <th>Sl#</th><th>Medicine</th><th>Composition</th><th>Supplier</th>
                                                        <th>Batch</th><th>Pkg Qty</th><th>Loose Qty</th><th>Expiry</th>
                                                        <th>MRP</th><th>Status</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    {categoryMedicines.map((med, idx) => {
                                                        const expired = isExpired(med.purchase_item_expiry_month, med.purchase_item_expiry_year);
                                                        return (
                                                            <tr key={idx}>
                                                                <td>{idx + 1}</td>
                                                                <td><strong>{med.purchase_item_medicine}</strong></td>
                                                                <td style={{ maxWidth: '200px' }}>
                                                                    {med.composition ? (
                                                                        <span className="badge bg-success-subtle text-success"
                                                                            style={{ whiteSpace: 'normal', wordBreak: 'break-word', textAlign: 'left', display: 'inline-block', lineHeight: '1.3', padding: '6px 8px' }}>
                                                                            {med.composition}
                                                                        </span>
                                                                    ) : '-'}
                                                                </td>
                                                                <td>{med.purchase_supplier}</td>
                                                                <td><span className="badge bg-info-subtle text-info">{med.purchase_item_batch}</span></td>
                                                                <td className="text-center"><span className="badge bg-primary">{med.purchase_item_qty_stock || 0}</span></td>
                                                                <td className="text-center"><span className="badge bg-info">{med.purchase_item_tab_cap_stock || 0}</span></td>
                                                                <td>{formatExpiryDate(med.purchase_item_expiry_month, med.purchase_item_expiry_year)}</td>
                                                                <td className="text-end">₹{parseFloat(med.purchase_item_mrp || 0).toFixed(2)}</td>
                                                                <td><span className={`badge ${expired ? 'bg-danger' : 'bg-success'}`}>{expired ? 'Expired' : 'Active'}</span></td>
                                                            </tr>
                                                        );
                                                    })}
                                                </tbody>
                                            </table>
                                        </div>
                                    ) : (
                                        <div className="text-center py-5">
                                            <i className="ri-inbox-line" style={{ fontSize: '48px', color: '#ccc' }}></i>
                                            <p className="mt-3 text-muted">No medicines found in <strong>{selectedCategory.name}</strong> category</p>
                                        </div>
                                    )}
                                </div>
                                <div className="modal-footer">
                                    <button type="button" className="btn btn-secondary" onClick={() => setShowCategoryModal(false)}>Close</button>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="modal-backdrop fade show" style={{ zIndex: 1055 }}></div>
                </>
            )}

            {/* EXPIRING MEDICINES MODAL */}
            {showExpiryAlert && (
                <>
                    <div className="modal fade show" style={{ display: 'block' }} tabIndex="-1">
                        <div className="modal-dialog modal-xl modal-dialog-scrollable">
                            <div className="modal-content">
                                <div className="modal-header bg-warning text-dark">
                                    <h5 className="modal-title">
                                        <i className="ri-alarm-warning-line me-2"></i>
                                        Medicines Expiring Within 30 Days ({expiringMedicines.length})
                                    </h5>
                                    <button type="button" className="btn-close" onClick={() => setShowExpiryAlert(false)}></button>
                                </div>
                                <div className="modal-body">
                                    {expiringMedicines.length > 0 ? (
                                        <div className="table-responsive">
                                            <table className="table table-bordered table-hover">
                                                <thead className="table-warning">
                                                    <tr>
                                                        <th>Sl. No.</th><th>Medicine</th><th>Supplier</th>
                                                        <th>Batch</th><th>Expiry</th><th>Days Left</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    {expiringMedicines.map((medicine, index) => (
                                                        <tr key={index}>
                                                            <td>{index + 1}</td>
                                                            <td><strong>{medicine.medicine_name}</strong></td>
                                                            <td>{medicine.supplier_name}</td>
                                                            <td>{medicine.batch_no}</td>
                                                            <td>{medicine.expiry_date}</td>
                                                            <td>{medicine.days_remaining}</td>
                                                        </tr>
                                                    ))}
                                                </tbody>
                                            </table>
                                        </div>
                                    ) : (
                                        <div className="text-center py-5">
                                            <i className="ri-check-line text-success" style={{ fontSize: '48px' }}></i>
                                            <p className="mt-3">No medicines expiring within 30 days</p>
                                        </div>
                                    )}
                                </div>
                                <div className="modal-footer">
                                    <button type="button" className="btn btn-secondary" onClick={() => setShowExpiryAlert(false)}>Close</button>
                                    {expiringMedicines.length > 0 && (
                                        <button type="button" className="btn btn-danger" onClick={exportExpiringMedicinesToPDF}>
                                            <i className="ri-file-pdf-line me-1"></i> Export PDF
                                        </button>
                                    )}
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="modal-backdrop fade show"></div>
                </>
            )}







{showAddAdjModal && (
    <>
        <div className="modal fade show" style={{ display: 'block', zIndex: 1070 }} tabIndex="-1">
            <div className="modal-dialog modal-lg modal-dialog-centered">
                <div className="modal-content">
                    <div className="modal-header" style={{
                        backgroundColor: adjFormData.adj_type === 'IN' ? '#198754'
                                      : adjFormData.adj_type === 'OUT' ? '#dc3545'
                                      : '#fd7e14',
                        color: '#fff'
                    }}>
                        <h5 className="modal-title">
                            <i className="ri-edit-box-line me-2"></i>
                            Stock Adjustment — {adjFormData.adj_type}
                        </h5>
                        <button type="button" className="btn-close btn-close-white"
                            onClick={closeAddAdjModal} disabled={adjSaving}></button>
                    </div>
                    <div className="modal-body">
 
                        {/* Type selector */}
                        <div className="mb-3">
                            <label className="form-label fw-bold">Adjustment Type</label>
                            <div className="btn-group w-100" role="group">
                                <button type="button"
                                    className={`btn ${adjFormData.adj_type === 'IN' ? 'btn-success' : 'btn-outline-success'}`}
                                    onClick={() => setAdjFormData(prev => ({ ...prev, adj_type: 'IN', adj_reason: '', adj_transfer_to: '' }))}>
                                    <i className="ri-arrow-down-line me-1"></i> IN (Add Stock)
                                </button>
                                <button type="button"
                                    className={`btn ${adjFormData.adj_type === 'OUT' ? 'btn-danger' : 'btn-outline-danger'}`}
                                    onClick={() => setAdjFormData(prev => ({ ...prev, adj_type: 'OUT', adj_reason: '', adj_transfer_to: '' }))}>
                                    <i className="ri-arrow-up-line me-1"></i> OUT (Remove)
                                </button>
                                <button type="button"
                                    className={`btn ${adjFormData.adj_type === 'TRANSFER' ? 'btn-warning' : 'btn-outline-warning'}`}
                                    onClick={() => setAdjFormData(prev => ({ ...prev, adj_type: 'TRANSFER', adj_reason: 'Transfer to staff' }))}>
                                    <i className="ri-share-forward-line me-1"></i> TRANSFER
                                </button>
                            </div>
                        </div>
 
                        {/* Medicine + Batch selector */}
                        <div className="mb-3">
                            <label className="form-label fw-bold">
                                <i className="ri-medicine-bottle-line me-1"></i>
                                Medicine + Batch <span className="text-danger">*</span>
                            </label>
                            <Select
                                options={stockOptionsForAdjustment}
                                value={selectedStockOption}
                                onChange={handleAdjStockSelect}
                                placeholder="Search medicine name or batch..."
                                isSearchable={true} isClearable={true}
                                styles={{
                                    menu: (base) => ({ ...base, zIndex: 99999 }),
                                    menuPortal: (base) => ({ ...base, zIndex: 99999 })
                                }}
                                menuPortalTarget={document.body}
                            />
                            {adjFormData.purchase_item_id && (
                                <div className="alert alert-info mt-2 mb-0 py-2">
                                    <small>
                                        <strong>Current Stock:</strong>{' '}
                                        <span className="badge bg-primary">
                                            {adjFormData.current_pkg_stock} pkg
                                        </span>{' '}
                                        <span className="badge bg-info">
                                            {adjFormData.current_loose_stock} loose
                                        </span>
                                    </small>
                                </div>
                            )}
                        </div>
 
                        {/* Quantities */}
                        <div className="row mb-3">
                            <div className="col-md-6">
                                <label className="form-label fw-bold">Package Qty</label>
                                <input type="number" className="form-control" min="0" step="any"
                                    value={adjFormData.adj_pkg_qty}
                                    onChange={(e) => setAdjFormData(prev => ({ ...prev, adj_pkg_qty: e.target.value }))}
                                    placeholder="0" />
                            </div>
                            <div className="col-md-6">
                                <label className="form-label fw-bold">Loose Qty (tab/cap)</label>
                                <input type="number" className="form-control" min="0" step="any"
                                    value={adjFormData.adj_loose_qty}
                                    onChange={(e) => setAdjFormData(prev => ({ ...prev, adj_loose_qty: e.target.value }))}
                                    placeholder="0" />
                            </div>
                            <div className="col-12">
                                <small className="text-muted">
                                    Enter one or both. Loose = strips/tablets/capsules.
                                </small>
                            </div>
                        </div>
 
                        {/* Reason */}
                        <div className="mb-3">
                            <label className="form-label fw-bold">
                                Reason <span className="text-danger">*</span>
                            </label>
                            <select className="form-select"
                                value={adjFormData.adj_reason}
                                onChange={(e) => setAdjFormData(prev => ({ ...prev, adj_reason: e.target.value }))}>
                                <option value="">-- Select Reason --</option>
                                {(reasonOptions[adjFormData.adj_type] || []).map(r => (
                                    <option key={r} value={r}>{r}</option>
                                ))}
                            </select>
                        </div>
 
                        {/* Transfer-to field — only shown when TRANSFER */}
                        {adjFormData.adj_type === 'TRANSFER' && (
                            <div className="mb-3">
                                <label className="form-label fw-bold">
                                    <i className="ri-user-line me-1"></i>
                                    Transfer To (Doctor / Staff Name) <span className="text-danger">*</span>
                                </label>
                                <input type="text" className="form-control"
                                    value={adjFormData.adj_transfer_to}
                                    onChange={(e) => setAdjFormData(prev => ({ ...prev, adj_transfer_to: e.target.value }))}
                                    placeholder="e.g. Dr. Sharma / Mr. Kumar (staff)" />
                            </div>
                        )}
 
                        {/* Remarks */}
                        <div className="mb-3">
                            <label className="form-label fw-bold">Remarks (optional)</label>
                            <textarea className="form-control" rows="2"
                                value={adjFormData.adj_remarks}
                                onChange={(e) => setAdjFormData(prev => ({ ...prev, adj_remarks: e.target.value }))}
                                placeholder="Any additional notes..."></textarea>
                        </div>
 
                        <div className="alert alert-warning py-2 small mb-0">
                            <i className="ri-information-line me-1"></i>
                            This is <strong>NOT a sale</strong>. It will not appear in Sale List or
                            affect Profit/Loss. Only stock quantity changes.
                        </div>
 
                    </div>
                    <div className="modal-footer">
                        <button type="button" className="btn btn-secondary"
                            onClick={closeAddAdjModal} disabled={adjSaving}>
                            <i className="ri-close-line me-1"></i> Cancel
                        </button>
                        <button type="button" className="btn btn-primary"
                            onClick={handleSaveAdjustment} disabled={adjSaving}>
                            {adjSaving ? (
                                <><span className="spinner-border spinner-border-sm me-1" /> Saving...</>
                            ) : (
                                <><i className="ri-save-line me-1" /> Save Adjustment</>
                            )}
                        </button>
                    </div>
                </div>
            </div>
        </div>
        <div className="modal-backdrop fade show" style={{ zIndex: 1065 }}></div>
    </>
)}


{showAdjListModal && (
    <>
        <div className="modal fade show" style={{ display: 'block', zIndex: 1060 }} tabIndex="-1">
            <div className="modal-dialog modal-xl modal-dialog-scrollable">
                <div className="modal-content">
                    <div className="modal-header bg-dark text-white">
                        <h5 className="modal-title">
                            <i className="ri-list-settings-line me-2"></i>
                            Stock Adjustment History
                        </h5>
                        <button type="button" className="btn-close btn-close-white"
                            onClick={closeAdjListModal}></button>
                    </div>
                    <div className="modal-body">
 
                        {/* Filters */}
                        <div className="row g-2 mb-3">
                            <div className="col-md-2">
                                <label className="form-label small">From Date</label>
                                <input type="date" className="form-control form-control-sm"
                                    value={adjListFilters.from_date}
                                    onChange={(e) => setAdjListFilters(prev => ({ ...prev, from_date: e.target.value }))} />
                            </div>
                            <div className="col-md-2">
                                <label className="form-label small">To Date</label>
                                <input type="date" className="form-control form-control-sm"
                                    value={adjListFilters.to_date}
                                    onChange={(e) => setAdjListFilters(prev => ({ ...prev, to_date: e.target.value }))} />
                            </div>
                            <div className="col-md-2">
                                <label className="form-label small">Type</label>
                                <select className="form-select form-select-sm"
                                    value={adjListFilters.filter_type}
                                    onChange={(e) => setAdjListFilters(prev => ({ ...prev, filter_type: e.target.value }))}>
                                    <option value="all">All</option>
                                    <option value="IN">IN</option>
                                    <option value="OUT">OUT</option>
                                    <option value="TRANSFER">TRANSFER</option>
                                </select>
                            </div>
                            <div className="col-md-3">
                                <label className="form-label small">Search</label>
                                <input type="text" className="form-control form-control-sm"
                                    placeholder="Medicine / batch / reason / user..."
                                    value={adjListFilters.search_key}
                                    onChange={(e) => setAdjListFilters(prev => ({ ...prev, search_key: e.target.value }))} />
                            </div>
                            <div className="col-md-3 d-flex align-items-end">
                                <button className="btn btn-primary btn-sm w-100" onClick={fetchAdjustmentList}>
                                    <i className="ri-search-line me-1"></i> Apply
                                </button>
                            </div>
                        </div>
 
                        {/* Summary cards */}
                        <div className="row g-2 mb-3">
                            <div className="col-md-3">
                                <div className="card bg-success-subtle">
                                    <div className="card-body py-2 text-center">
                                        <small className="text-muted d-block">Stock IN</small>
                                        <div className="fs-6 fw-bold text-success">
                                            {adjListSummary.total_in_pkg || 0} pkg
                                            <small className="text-muted ms-1">/ {adjListSummary.total_in_loose || 0} loose</small>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="col-md-3">
                                <div className="card bg-danger-subtle">
                                    <div className="card-body py-2 text-center">
                                        <small className="text-muted d-block">Stock OUT</small>
                                        <div className="fs-6 fw-bold text-danger">
                                            {adjListSummary.total_out_pkg || 0} pkg
                                            <small className="text-muted ms-1">/ {adjListSummary.total_out_loose || 0} loose</small>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="col-md-3">
                                <div className="card bg-warning-subtle">
                                    <div className="card-body py-2 text-center">
                                        <small className="text-muted d-block">Transferred</small>
                                        <div className="fs-6 fw-bold text-warning">
                                            {adjListSummary.total_transfer_pkg || 0} pkg
                                            <small className="text-muted ms-1">/ {adjListSummary.total_transfer_loose || 0} loose</small>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="col-md-3">
                                <div className="card bg-info-subtle">
                                    <div className="card-body py-2 text-center">
                                        <small className="text-muted d-block">Total Records</small>
                                        <div className="fs-6 fw-bold text-info">
                                            {adjListSummary.total_records || 0}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
 
                        {/* Table */}
                        {adjListLoading ? (
                            <div className="text-center py-5">
                                <div className="spinner-border text-primary"></div>
                                <p className="mt-3 text-muted">Loading adjustments...</p>
                            </div>
                        ) : adjList.length > 0 ? (
                            <div className="table-responsive">
                                <table className="table table-bordered table-hover table-sm align-middle">
                                    <thead style={{ backgroundColor: '#405189', color: '#fff' }}>
                                        <tr>
                                            <th>Sl#</th>
                                            <th>Date/Time</th>
                                            <th>Type</th>
                                            <th>Medicine</th>
                                            <th>Batch</th>
                                            <th>Pkg Qty</th>
                                            <th>Loose Qty</th>
                                            <th>Reason</th>
                                            <th>Transfer To</th>
                                            <th>Remarks</th>
                                            <th>By</th>
                                            <th>Action</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {adjList.map((r, idx) => {
                                            const typeColor = r.adj_type === 'IN' ? 'success'
                                                           : r.adj_type === 'OUT' ? 'danger'
                                                           : 'warning';
                                            const sign = r.adj_type === 'IN' ? '+' : '-';
                                            return (
                                                <tr key={r.adj_id}>
                                                    <td>{idx + 1}</td>
                                                    <td>{formatBillDate(r.adj_datetime)}<br/>
                                                        <small className="text-muted">
                                                            {String(r.adj_datetime).split(' ')[1] || ''}
                                                        </small>
                                                    </td>
                                                    <td>
                                                        <span className={`badge bg-${typeColor}`}>
                                                            {r.adj_type}
                                                        </span>
                                                    </td>
                                                    <td><strong>{r.adj_medicine}</strong></td>
                                                    <td>
                                                        <span className="badge bg-info-subtle text-info">
                                                            {r.adj_batch || '-'}
                                                        </span>
                                                    </td>
                                                    <td className="text-center fw-bold text-{typeColor}">
                                                        {parseFloat(r.adj_pkg_qty) > 0 ? `${sign}${r.adj_pkg_qty}` : '-'}
                                                    </td>
                                                    <td className="text-center fw-bold">
                                                        {parseFloat(r.adj_loose_qty) > 0 ? `${sign}${r.adj_loose_qty}` : '-'}
                                                    </td>
                                                    <td>{r.adj_reason}</td>
                                                    <td>{r.adj_transfer_to || '-'}</td>
                                                    <td>
                                                        <small>{r.adj_remarks || '-'}</small>
                                                    </td>
                                                    <td><small>{r.adj_user_name || '-'}</small></td>
                                                    <td>
                                                        <button className="btn btn-sm btn-outline-danger"
                                                            title="Delete (reverses stock change)"
                                                            onClick={() => handleDeleteAdjustment(r.adj_id, r.adj_medicine)}>
                                                            <i className="ri-delete-bin-line"></i>
                                                        </button>
                                                    </td>
                                                </tr>
                                            );
                                        })}
                                    </tbody>
                                </table>
                            </div>
                        ) : (
                            <div className="text-center py-5">
                                <i className="ri-inbox-line" style={{ fontSize: '48px', color: '#ccc' }}></i>
                                <p className="mt-3 text-muted">No adjustments found in this period</p>
                            </div>
                        )}
                    </div>
                    <div className="modal-footer">
                        <button type="button" className="btn btn-success"
                            onClick={() => { closeAdjListModal(); openAddAdjModal(); }}>
                            <i className="ri-add-line me-1"></i> Add New
                        </button>
                        <button type="button" className="btn btn-secondary" onClick={closeAdjListModal}>
                            Close
                        </button>
                    </div>
                </div>
            </div>
        </div>
        <div className="modal-backdrop fade show" style={{ zIndex: 1055 }}></div>
    </>
)}
            <style>{`
                @media print {
                    .no-print { display: none !important; }
                    .card { box-shadow: none !important; border: 1px solid #ddd !important; }
                    body { print-color-adjust: exact; -webkit-print-color-adjust: exact; }
                }
                .rotating { animation: rotate 1s linear infinite; }
                @keyframes rotate { from { transform: rotate(0deg); } to { transform: rotate(360deg); } }
            `}</style>
        </div>
    );
}

export default StockReports;